import { queryClient, trpc, trpcClient } from "~/utils/trpc";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { TRPCClientError } from "@trpc/client";

export const Route = createFileRoute("/_dashboard/$datasetSlug")({
  loader: async ({ params, location }) => {
    const slug = params.datasetSlug;

    const handleAccessError = (error: unknown): never => {
      if (error instanceof TRPCClientError && ["UNAUTHORIZED", "FORBIDDEN", "NOT_FOUND"].includes(error.data?.code)) {
        throw redirect({ to: "/select-dataset", search: { redirectTo: location.href } });
      }

      // A failed batch or server request must not restart dataset selection and MFA.
      throw error;
    };

    const dataset = await queryClient
      .fetchQuery(trpc.datasets.getBySlug.queryOptions({ slug }))
      .catch(handleAccessError);

    const session = await queryClient.fetchQuery(trpc.auth.getSession.queryOptions()).catch(handleAccessError);

    if (session?.slug !== slug) {
      let result: Awaited<ReturnType<typeof trpcClient.auth.selectDataset.mutate>> | null = null;

      try {
        result = await trpcClient.auth.selectDataset.mutate({ datasetId: dataset.id });
        await queryClient.invalidateQueries();
      } catch (error) {
        handleAccessError(error);
      }

      if (result?.redirectPath === "/mfa") {
        throw redirect({
          to: "/mfa",
          search: {
            redirectTo: location.href,
          },
        });
      }
    }

    return { dataset };
  },
});
